import { createStore, createHook, defaults } from 'react-sweet-state';
import { find, merge, map } from 'lodash';

// Integrate react-sweet-state with the redux dev tools.
defaults.devtools = true;

export const UP = 'up';
export const DOWN = 'down';
export const TIMEOUT = 'timeout';
export const UNKNOWN = 'unknown';

const emptyPlmState = {
    plms: [],
};

function addPlms(plmList) {
    return ({ getState, setState }) => {
        const { plms: oldState } = getState();

        const newState = map(plmList, (plm) => {
            const oldPlm = find(oldState, { name: plm.name }) || {};
            return merge({}, oldPlm, plm);
        });

        setState({ plms: newState });
    };
}

function addStatuses(plmMap) {
    return ({ getState, setState }) => {
        const { plms: oldState } = getState();

        const newState = map(oldState, (oldPlm) => merge({}, oldPlm, plmMap[oldPlm.name]));

        setState({ plms: newState });
    };
}

const Store = createStore({
    name: 'PlmState',

    initialState: emptyPlmState,

    actions: {
        addStatuses,
        addPlms,
    },
});

export const usePlms = createHook(Store, {
    selector: (state) => state?.plms,
});
